import React from 'react';
import { CheckCircle, XCircle, Info, AlertTriangle, X } from 'lucide-react';

const toastIcons = {
  success: CheckCircle,
  error: XCircle,
  info: Info,
  warning: AlertTriangle,
};

const toastStyles = {
  success: 'bg-green-100 border-green-500 text-green-700',
  error: 'bg-red-100 border-red-500 text-red-700',
  info: 'bg-blue-100 border-blue-500 text-blue-700',
  warning: 'bg-yellow-100 border-yellow-500 text-yellow-700',
};

const Toast = ({ toast, onRemove }) => {
  const Icon = toastIcons[toast.type];
  
  return (
    <div className={`
      fixed top-24 right-4 z-50 max-w-md p-4 border-l-4 rounded-lg shadow-lg
      backdrop-filter backdrop-blur-sm bg-opacity-95
      transform transition-all duration-300 ease-in-out
      ${toastStyles[toast.type]}
    `}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Icon className="w-5 h-5 mr-3 flex-shrink-0" />
          <p className="body-medium">{toast.message}</p>
        </div>
        <button
          onClick={() => onRemove(toast.id)}
          className="ml-4 text-current opacity-70 hover:opacity-100 transition-opacity"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

const ToastContainer = ({ toasts, onRemove }) => {
  return (
    <div className="fixed top-0 right-0 z-50 pointer-events-none">
      <div className="pointer-events-auto">
        {toasts.map((toast, index) => (
          <div
            key={toast.id}
            style={{ 
              transform: `translateY(${index * 10}px)`,
              zIndex: 1000 - index 
            }}
          >
            <Toast toast={toast} onRemove={onRemove} />
          </div>
        ))}
      </div>
    </div>
  );
};

export { Toast, ToastContainer };
export default ToastContainer;